/**
 * Utilidades compartidas por las dos gráficas de Histórico - Evolución de
 * Precios (la de la vista y la del modal de presentación).
 */

/**
 * Número de puntos a partir del cual la gráfica se considera "larga": se apagan
 * animación y marcadores porque con rangos de 180+ días el dibujado se vuelve
 * lento y los marcadores se enciman hasta hacer ilegible la línea.
 */
export const LONG_RANGE_POINTS = 120;

/**
 * Vida de la caché de rangos ya consultados. Los precios de la CRE llegan con
 * ~15 min de desfase, así que reusar unos minutos la respuesta no cambia lo que
 * ve el usuario y evita volver a pedir el histórico completo al alternar rangos.
 */
export const CACHE_TTL_MS = 5 * 60 * 1000;

/**
 * Devuelve la respuesta guardada para esa clave si sigue vigente; si caducó la
 * descarta. Null significa que hay que pedirla al API.
 */
export function readCache(cache: Map<string, { at: number; data: any }>, key: string) {
  const hit = cache.get(key);
  if (!hit) {
    return null;
  }
  if (Date.now() - hit.at >= CACHE_TTL_MS) {
    cache.delete(key);
    return null;
  }
  return hit.data;
}

/**
 * Tooltip compartido de las series de precio: lista todas las estaciones que
 * comparten el mismo precio en la fecha señalada. Ubica el punto por índice en
 * vez de recorrer todos los puntos de cada serie, que con rangos largos hacía
 * que cada hover recorriera miles de puntos.
 */
export function sharedPriceTooltipFormatter(this: any): string {
  const index = this['point'].index;
  let tooltip = '<span style="font-size: 10px">' + this.x + '</span><br/>';
  this.series.chart.series.forEach((series: any) => {
    let point = series.points[index];
    if (!point || point.x !== index) {
      point = series.points.find((p: any) => p.x === index);
    }
    if (point && point.y === this.y) {
      tooltip += '<span style="color:' + series.color + '">●</span> ' + series.name + ': <b>$ ' + point.y.toFixed(2) + '</b><br/>';
    }
  });
  return tooltip;
}
